/**
 * 产品金额千分符
 * @param {amount}  转换数值
 * @param {dealWithBol} 是否处理原数据保留几位小数
 * @param {fixed} 保留几位小数
 * @returns
 */
export function addThousandSeparator(amount, dealWithBol = false, fixed = 2) {
  if (amount) {
    if (dealWithBol) {
      amount = amount * 1; // 转化为数字
      amount = amount.toFixed(fixed); //先转化为两位小数
    }
    return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
}
